var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('BaseCenterWrapper',[_c('h1',{staticClass:"app-title white--text text-center"},[_vm._v("eBassets")]),_c('router-view')],1),_c('div',{staticClass:"wave-1"}),_c('div',{staticClass:"wave-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }